/* global slideColours */
export default {
  init() {

    $('.scroll-down').click(() => {
      $('html, body').animate({
        scrollTop: $(window).height(),
      }, 600);
    });

    function animateHeader() {
      if ($(window).width() > 1400) {
        const scrollTop = window.scrollY;
        const screenWidth = $('body').innerWidth();
        const animationSpeed = 0.1;
        const delay = 0;
        let value = scrollTop * animationSpeed - delay;
        value = value < 0 ? 0 : value;
        const width = (1 - value / 100) * screenWidth + 'px';
        const offset = 'calc(-' + screenWidth * 0.5 + 'px + 50% + ' + value * 0.5 / 100 * screenWidth + 'px)';
        const opacity = 1 - scrollTop / ($(window).height() * 0.6);
        // Banner
        $('.banner-image-home').css({
          'width': width,
          'margin-left': offset,
        });
        $('.banner-image-home .slick-slider .content-wrapper, .banner-image-home .slick-slider video').css('opacity', opacity);

        // Top Bar
        $('.g-fas.fixed, .nav-wrap.fixed').css({
          'width': width,
          'left': offset,
        });
        if ($('.banner-image-home').width() < 1400) {
          $('.banner-image-home').css({
            'width': 1400,
            'margin-left': 0,
          });
          $('.g-fas.fixed, .nav-wrap.fixed').css({
            'width': 1400,
            'left': screenWidth * 0.5 - 700 + 'px',
          });
        }
      }
    }

    animateHeader();

    $('#hp-slider .cover-image').css('margin-top', $('.nav-wrap').height() + $('.nav-wrap').offset().top - $('.site-container').offset().top + 'px');

    // Header animation
    $(window).scroll(function () {
      animateHeader();
    });

    $.fn.removeClassRegEx = function (regex) {
      if (regex && (typeof regex === 'string' || typeof regex === 'object')) {
        regex = typeof regex === 'string' ? regex = new regex(regex) : regex;
        $(this).each(function () {
          $(this).removeClass(function (i, c) {
            var classes = [];
            $.each(c.split(' '), function (i, c) {
              if (regex.test(c)) { classes.push(c); }
            });
            return classes.join(' ');
          });
        });
      }
      return this;
    }

    const initialSlide = $('#hp-slider').data('initial-slide');
    const initialSlideTime = $('#hp-slider .hp-single-slide:first-of-type')[0].dataset.timer;

    // Init slick slider homepage
    let hpSlider = $("#hp-slider").slick({
      arrows: true,
      prevArrow: $(".header-prev"),
      nextArrow: $(".header-next"),
      variableWidth: true,
      initialSlide: initialSlide,
      autoplaySpeed: parseInt(initialSlideTime),
      autoplay: true,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      swipe: false,
      // fade: true,
    });

    // Change navigation class and play next video
    hpSlider.on('afterChange', function (event, slick, currentSlide) {
      let slideClass = slideColours[currentSlide].class;
      $('.nav-wrap, header.g-fas').removeClassRegEx(/^nav-colour/).addClass(slideClass);
      const video = $(`div[data-slick-index='${currentSlide}']`).find('video').get(0);

      const autoPlayTime = parseInt($('.slick-active')[0].dataset.timer);

      if (video) {
        video.play();
      }

      hpSlider.slick('slickSetOption', 'autoplaySpeed', autoPlayTime);
    });

    hpSlider.on('beforeChange', function (event, slick, currentSlide) {
      const video = $(`div[data-slick-index='${currentSlide}']`).find('video').get(0);
      if (video) {
        video.pause();
      }
    });

    const publicSlides = [];

    hpSlider.find(".slick-slide").each(function (index) {
      if (!$(this).find("[data-secret='true']").length) {
        publicSlides.push(index);
      }
    });

    function getNextPublicSlide(current) {
      const currentIndex = publicSlides.indexOf(current);

      if (currentIndex === publicSlides.length - 1) {
        return publicSlides[0];
      }

      return publicSlides[currentIndex + 1];
    }

    function getPrevPublicSlide(current) {
      const currentIndex = publicSlides.indexOf(current);

      if (currentIndex <= 0) {
        return publicSlides[publicSlides.length - 1];
      }

      return publicSlides[currentIndex - 1];
    }

    $(".header-next").on("click", function (e) {
      e.preventDefault();

      const current = hpSlider.slick("slickCurrentSlide");

      hpSlider.slick("slickGoTo", getNextPublicSlide(current));
    });

    $(".header-prev").on("click", function (e) {
      e.preventDefault();

      const current = hpSlider.slick("slickCurrentSlide");

      hpSlider.slick("slickGoTo", getPrevPublicSlide(current));
    });


    $('.slide-pager li a').click(function (e) {
      e.preventDefault();
      let gotToSlide = $(this).data('slide-index');
      hpSlider.slick('slickGoTo', gotToSlide);
    });

    /**
      * On scroll set fixed header
    */
    $(window).scroll(function () {
      let sticky = $('.nav-wrap, header.g-fas');
      let scroll = $(window).scrollTop();
      const height = $(window).height() - $('.g-fas').height() - $('.nav-wrap').height();

      if (scroll >= height) {
        sticky.removeClassRegEx(/^nav-colour/);
        $(".icon-light").hide();
        $(".icon-dark").show();
      } else {
        let slideIndex = $('#hp-slider .slick-current').data('slick-index');
        let slideClass = slideColours[slideIndex].class;
        sticky.addClass(slideClass);
        if (slideClass === "nav-colour-black" || slideClass === "nav-colour-transparent") {
          $(".icon-light").show();
          $(".icon-dark").hide();
        } else {
          $(".icon-light").hide();
          $(".icon-dark").show();
        }
      }
    });
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js